import { AssignConfig } from './assign.abstract.config';

export const assignConfig: AssignConfig = {
  privileges: {
    assigned: { // TODO(MOJAT-3794): rename to shortlist after deploying epic
      candidates: 'web:assigned-candidates',
      jobs: 'web:assigned-jobs',
    },
    hiringManager: 'hiring-manager',
  },
};
